/** Folder detail lives at the singular `/folder/:id`, outside the `/folders` list route. */
export const getFolderDetailPath = (folderId: string): string => `/folder/${folderId}`;
